import { IonCol, IonGrid, IonItem, IonList, IonRow, IonToggle, IonToast, IonLabel } from '@ionic/react'
import Calendar from '../../../../components/calendar/Calendar.component'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SingleSelect from '../../../../components/singleSelect/SingleSelect.component'
import { IOption, IPNNVOption } from '../../../../common/common.types'
import { AccordianComponent } from '../../../../components/accordian/Accordian.components'
import './Neuro.content.css'
import {
  setThromScreen,
  setThromScreenPNNV,
  setStrokeScale,
  setStrokeScalePNNV,
  setStrokeCvaSymptomsResolved,
  setStrokeCvaSymptomsResolvedPNNV,
  setHeadLossCons,
  setDtBaselineSeen,
  setChemParalyzed,
  saveNeuro,
  setMotorSensoryViaChemParalyzed,
  setHeadConsciousness,
  setDtBaselineSeenPNNV,
} from '../store/neuro.actions'
import { useDispatch, useSelector } from 'react-redux'
import { ToastColor } from '../../../../components/toast/store/toast.constants'
import { getToastProps } from '../../../../components/toast/toastIcon.util'
import { getNeuroSelector } from '../selectors'
import MotorSensoryAssessmentContent from '../motorSensoryAssessment/content/MotorSensoryAssessment.content'
import PupilsContent from '../pupils/content/Pupils.content'
import Comment from '../../../../components/comment/Comment.component'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import { getAllPNNVOptionsSelector, getNeuroOptionsSelector } from '../../../options/selectors'
import { getDatapointsConfigSelector } from '../../../configurations/selectors'
import { getMotorSensoryAssessmentSelector } from '../motorSensoryAssessment/selectors'
import { getPupilsSelector } from '../pupils/selectors'

import ScoreButton from '../../../../components/scoreButton/ScoreButton.component'
import { useHistory } from 'react-router'
import WasPatientImmobilized from '../wasPatientImmobilized/content/WasPatientImmobilized.content'
import { getWasPatientImmbobilizedSelector } from '../wasPatientImmobilized/selectors'
import {
  resetWasPatientImmobilized,
  saveWasPatientImmobilized,
} from '../wasPatientImmobilized/store/wasPatientImmobilized.actions'
import { toggleWasPtImm } from '../store/neuro.actions'
import './Neuro.content.css'
import { IDataPointsConfig } from '../../../configurations/store/configurations.types'
import { getTripInformationSelector } from '../../../tripInformation/selectors'
import { getRevisedTraumaScoreSelector } from '../revisedTraumaScore/selectors'
import { IRevisedTraumaScoreState } from '../revisedTraumaScore/store/revisedTraumaScore.types'
import { getPediatricTraumaScoreSelector } from '../pediatricTraumaScore/selectors'
import { IPediatricTraumaScoreState } from '../pediatricTraumaScore/store/pediatricTraumaScore.types'
import { getGlassgowCommaScoreSelector } from '../glassgowCommaScore/selectors'
import { IGlassgowCommaScoreState } from '../glassgowCommaScore/store/glassgowCommaScore.types'
import { getPatientDemographicsSelector } from '../../../patientDemographics/selectors'
import { IPatientDemographicsState } from '../../../patientDemographics/store/patientDemographics.types'
import { isAgeLessThan } from '../../../../utilities/data.util'
import { IAlertState } from '../../../../components/alert/store/alert.types'
import { showAlert } from '../../../../components/alert/store/alert.actions'
import { getAllowedStrokeScoreIds, IStrokeScaleConfigOption } from '../strokeScore/utils/strokeScaleScore.util'
import useDeviceMetrics from '../../../../utilities/useDeviceMetrics'

const NeuroContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { isTablet } = useDeviceMetrics()
  const neuro = useSelector(getNeuroSelector)
  const {
    dtBaselineSeen,
    dtBaselineSeenPNNV,
    headConciousness,
    headLossCons,
    strokeCvaSymptomsResolved,
    strokeCvaSymptomsResolvedPNNV,
    strokeScale,
    strokeScalePNNV,
    thromScreen,
    headFindings,
    chemParalyzed,
    strokescaleScore,
    thromScreenPNNV,
  } = neuro
  const allPNNVOptions = useSelector(getAllPNNVOptionsSelector)
  const dateBaselineSeenOptions = allPNNVOptions?.['eSituation.18']
  const [chemicallyParalyzedToast, setChemicallyParalyzedToast] = useState(false)

  const isApproximateSelected = (pnnValue: IPNNVOption | null) => {
    return pnnValue?.id === 8801029
  }

  const motorSensory = useSelector(getMotorSensoryAssessmentSelector)
  const { headSensory, motorComments, motorLa, motorLl, motorRa, motorRl, sensoryLa, sensoryLl, sensoryRa, sensoryRl } =
    motorSensory
  const motorSensoryShow = Boolean(
    motorLa ||
      motorLl ||
      motorRa ||
      motorRl ||
      sensoryLa ||
      sensoryLl ||
      sensoryRa ||
      sensoryRl ||
      motorComments ||
      headSensory
  )

  const pupils = useSelector(getPupilsSelector)
  const { headReactive, pupilRxL, pupilRxR, pupilSizeL, pupilSizeR } = pupils
  const showPupils = Boolean(headReactive || pupilRxL || pupilRxR || pupilSizeL || pupilSizeR)

  const dataPointsConfig = useSelector(getDatapointsConfigSelector)
  const {
    DP_PUPIL_COMMENTS,
    DP_PUPIL_PICKLIST,
    DP_PUPIL_SIZELIST,
    DP_THROMBOLYTIC,
    DP_STROKE_SCALE,
    DP_MOTOR_COMMENTS,
    DP_MOTOR_PICKLIST,
    DP_SENSORY_COMMENTS,
    DP_SENSORY_PICKLIST,
    DP_NEURO_ASSESS,
  } = dataPointsConfig

  const showPupilsSection = DP_PUPIL_COMMENTS === 1 || DP_PUPIL_PICKLIST === 1 || DP_PUPIL_SIZELIST === 1

  const motorSensorySectionShow =
    DP_MOTOR_COMMENTS === 1 || DP_MOTOR_PICKLIST === 1 || DP_SENSORY_COMMENTS === 1 || DP_SENSORY_PICKLIST === 1

  const neuroOptions = useSelector(getNeuroOptionsSelector)
  const {
    headConciousnessOptions,
    strokeCvaSymptomsResolvedOptions,
    thromScreenOptions,
    headLossConsOptions,
    strokeScaleNeuroOptions,
    strokeScaleConfigOptions,
  } = neuroOptions

  const allowedScoreIds = getAllowedStrokeScoreIds(
    strokeScale?.id,
    strokeScaleConfigOptions as IStrokeScaleConfigOption[]
  )

  const history = useHistory()
  const wasPatientImmobilizedState = useSelector(getWasPatientImmbobilizedSelector)
  const neuroState = useSelector(getNeuroSelector)
  const { _toggleWasPtImmFlag } = neuroState

  const [disableDateTimePicker, setDisableDateTimePicker] = useState(0)

  const { immCollar, immCid, immLbb, immKed, immMast, immobBy, immobOutcome } = wasPatientImmobilizedState
  const isAccordionCheckMark = Boolean(immCollar || immCid || immLbb || immKed || immMast || immobBy || immobOutcome)

  const revisedTraumaScoreState: IRevisedTraumaScoreState = useSelector(getRevisedTraumaScoreSelector)
  const { rts } = revisedTraumaScoreState
  const rtsScore = rts

  const pediatricTraumaScoreState: IPediatricTraumaScoreState = useSelector(getPediatricTraumaScoreSelector)
  const { ptsTotal } = pediatricTraumaScoreState
  const ptsScore = ptsTotal

  const glassgowCommaScoreState: IGlassgowCommaScoreState = useSelector(getGlassgowCommaScoreSelector)
  const { gcs, gcsEyePNNV, gcsMotorPNNV, gcsVerbalPNNV, gcsPNNV } = glassgowCommaScoreState
  const gcsTotal = gcsEyePNNV || gcsMotorPNNV || gcsVerbalPNNV || gcsPNNV ? null : gcs || 'N/A'

  const tripInformationState: any = useSelector(getTripInformationSelector)
  const { patientCategory } = tripInformationState
  const showRtsFlag = Boolean(patientCategory?.show_rts) ?? true

  const patientInformationState: IPatientDemographicsState = useSelector(getPatientDemographicsSelector)
  const { age, ageUnit } = patientInformationState

  const ageFlag = age && isAgeLessThan(+age, ageUnit?.id?.toString() || '', 13)
  const datapointsConfig: IDataPointsConfig = useSelector(getDatapointsConfigSelector)
  const { DP_RTS, DP_INITGCS } = datapointsConfig

  const toggleWasPatientImmobilizedData = (toggleFlag: any) => {
    dispatch(toggleWasPtImm(toggleFlag))
    if (!toggleFlag) {
      dispatch(resetWasPatientImmobilized())
      saveWasPatientImmobilizedData()
    }
  }

  const saveWasPatientImmobilizedData = () => {
    dispatch(saveWasPatientImmobilized())
  }

  const save = () => {
    dispatch(saveNeuro())
  }

  const setLevelOfConsciousnessOnChange = (option: IOption) => {
    dispatch(setHeadConsciousness(option))
    save()
  }

  const setThrombolyticOnChange = (option: IOption) => {
    dispatch(setThromScreen(option))
    save()
  }

  const setThrombolyticPNNVOnChange = (pnnvOption: IPNNVOption | null) => {
    dispatch(setThromScreenPNNV(pnnvOption))
    save()
  }

  const handleUpdateStokeScale = (option: IOption) => {
    dispatch(setStrokeScale(option))
    save()
  }

  const setStrokeScalePNNVOnChange = (option: IOption) => {
    dispatch(setStrokeScalePNNV(option))
    save()
  }

  const setStrokeScaleOnChange = (option: IOption) => {
    if (strokescaleScore !== null) {
      const alert: IAlertState = {
        header: '',
        message: 'This will erase any saved scored scale information upon saving',
        buttons: [
          { text: t('common.buttons.Clear'), role: 'destructive', handler: () => handleUpdateStokeScale(option) },
          { text: t('common.buttons.Cancel') },
        ],
      }
      dispatch(showAlert(alert))
    } else {
      handleUpdateStokeScale(option)
    }
  }

  const setStrokeCvaSymptomsResolvedOnChange = (option: IOption) => {
    dispatch(setStrokeCvaSymptomsResolved(option))
    save()
  }

  const setStrokeCvaSymptomsResolvedPNNVOnChange = (pnnvOption: IPNNVOption | null) => {
    dispatch(setStrokeCvaSymptomsResolvedPNNV(pnnvOption))
    save()
  }

  const setConsciousnessOnChange = (option: IOption) => {
    dispatch(setHeadLossCons(option))
    save()
  }
  const setselectedDateOnChange = (value: string | null) => {
    dispatch(setDtBaselineSeen(value))
    save()
  }

  const setdateBaselineSeenPNNVOnChange = (pnnvOption: IPNNVOption | null) => {
    if (!dtBaselineSeen && isApproximateSelected(pnnvOption)) {
      const alertState: IAlertState = {
        header: '',
        message: 'To select approximate, Time Last Well Known is first required',
        buttons: [{ text: t('pnnv.ok') }],
      }
      dispatch(showAlert(alertState))
    } else {
      dispatch(setDtBaselineSeenPNNV(pnnvOption))
    }
    if (!isApproximateSelected(pnnvOption) && pnnvOption) dispatch(setDtBaselineSeen(''))
    save()
  }

  const onChangeChemicallyParalyzed = (e: CustomEvent) => {
    if (e.detail.checked) {
      dispatch(setChemParalyzed(1))
      setChemicallyParalyzedToast(true)
      const levelOfCossOptionArray = headConciousnessOptions
        .filter((item: any) => item?.chemParalysis === 1)
        .sort((a: any, b: any) => (a?.id > b?.id ? 1 : -1))
      let levelOfCossOption = null
      if (levelOfCossOptionArray.length > 0) {
        levelOfCossOption = levelOfCossOptionArray[0]
      }
      dispatch(setHeadConsciousness(levelOfCossOption))
    } else {
      dispatch(setChemParalyzed(0))
      setChemicallyParalyzedToast(true)
    }

    dispatch(setMotorSensoryViaChemParalyzed())
    save()
  }

  const onDateChange = (value: number) => {
    setDisableDateTimePicker(value)
  }

  const chemicallyParalyzedToastValue =
    "<span style={fontSize:larger}>Chemically Paralyzed</span>   <p style={{margin:'0px'}}>Glasgow Coma Score and Motor & Sensory have been updated from this Change</p>"

  return (
    <>
      {chemicallyParalyzedToast && (
        <IonToast
          isOpen={chemicallyParalyzedToast}
          position='top'
          message={chemicallyParalyzedToastValue}
          {...getToastProps(ToastColor.Info)}
          duration={2000}
          onDidDismiss={() => {
            setChemicallyParalyzedToast(false)
          }}
        />
      )}
      <>
        <IonList id='neuroContent' className={isTablet ? 'ion-margin-horizontal' : ''}>
          <IonGrid className='no-padding'>
            {showPupilsSection && (
              <IonRow>
                <IonCol className='ion-no-padding'>
                  <AccordianComponent
                    dataTestId={'Pupils'}
                    heading={t('neuro.Pupils')}
                    content={<PupilsContent />}
                    isCheckMark={showPupils}
                  />
                </IonCol>
              </IonRow>
            )}

            {motorSensorySectionShow && (
              <IonRow>
                <IonCol className='ion-no-padding'>
                  <AccordianComponent
                    dataTestId={'MotorSensoryAssessment'}
                    heading={t('neuro.MotorSensoryAssessment')}
                    content={<MotorSensoryAssessmentContent />}
                    isCheckMark={motorSensoryShow}
                  />
                </IonCol>
              </IonRow>
            )}

            <IonRow>
              <IonCol className='ion-no-padding font-roboto mt-8 picklist'>
                <SingleSelect
                  dataTestID='LevelOfConsciousness'
                  selectedOption={headConciousness}
                  listHeader={t('neuro.LevelOfConsciousness')}
                  label={t('neuro.LevelOfConsciousness')}
                  options={headConciousnessOptions}
                  action={setLevelOfConsciousnessOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />
            <Calendar
              dataTestID='TimeLastWellUnknown'
              selectedDate={dtBaselineSeen}
              action={setselectedDateOnChange}
              showToggle={false}
              toggleValue={disableDateTimePicker}
              toggleAction={onDateChange}
              isStateAction={true}
              pnnvOptions={dateBaselineSeenOptions}
              pnnvValue={dtBaselineSeenPNNV}
              pnnvAction={setdateBaselineSeenPNNVOnChange}
              pnnvListHeader={t('neuro.TimeLastWellKnown')}
              useBothNormalAndPertinent={isApproximateSelected(dtBaselineSeenPNNV)}
            />

            {DP_NEURO_ASSESS !== 1 && (
              <>
                <hr className='field-divider' />
                <IonRow>
                  <IonCol className='ion-no-padding'>
                    <Comment isDataPresent={headFindings.length > 0} path={TabConstants.INITIAL_ASSESSMENT_COMMENTS} />
                  </IonCol>
                </IonRow>
              </>
            )}

            <hr className='field-divider' />
            {DP_THROMBOLYTIC === 1 && (
              <>
                <IonRow>
                  <IonCol className='ion-no-padding font-roboto picklist'>
                    <SingleSelect
                      dataTestID='Thrombolytic'
                      selectedOption={thromScreen}
                      listHeader={t('neuro.Thrombolytic')}
                      label={t('neuro.Thrombolytic')}
                      options={thromScreenOptions}
                      action={setThrombolyticOnChange}
                      selectedPNNVOption={thromScreenPNNV}
                      pnnvAction={setThrombolyticPNNVOnChange}
                    />
                  </IonCol>
                </IonRow>
                <hr className='field-divider' />
              </>
            )}

            {DP_STROKE_SCALE === 1 && (
              <>
                <IonRow>
                  <IonCol className='ion-no-padding font-roboto picklist'>
                    <SingleSelect
                      dataTestID='StrokeScale'
                      selectedOption={strokeScale}
                      listHeader={t('neuro.StrokeScale')}
                      label={t('neuro.StrokeScale')}
                      options={strokeScaleNeuroOptions}
                      action={setStrokeScaleOnChange}
                      selectedPNNVOption={strokeScalePNNV}
                      pnnvAction={setStrokeScalePNNVOnChange}
                    />
                  </IonCol>
                </IonRow>
                <hr className='field-divider' />
              </>
            )}
            <IonRow>
              <IonCol className='ion-no-padding font-roboto picklist'>
                <SingleSelect
                  dataTestID='StrokeCvaSymptomsResolved'
                  selectedOption={strokeCvaSymptomsResolved}
                  listHeader={t('neuro.StrokeCvaSymptomsResolved')}
                  label={t('neuro.StrokeCvaSymptomsResolved')}
                  options={strokeCvaSymptomsResolvedOptions}
                  action={setStrokeCvaSymptomsResolvedOnChange}
                  selectedPNNVOption={strokeCvaSymptomsResolvedPNNV}
                  pnnvAction={setStrokeCvaSymptomsResolvedPNNVOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='ion-no-padding chemical-paralyzed' size='6'>
                <IonItem lines='none'>
                  <IonLabel>
                    <div className='toggle-chemicalparalyzed'>
                      <span>Chemically</span>
                      <span>Paralyzed</span>
                    </div>
                  </IonLabel>
                  <IonToggle
                    slot='start'
                    name='ChemicallyParalyzed'
                    color='zoll-blue-secondary'
                    checked={chemParalyzed === 1}
                    onIonChange={onChangeChemicallyParalyzed}
                  />
                </IonItem>
              </IonCol>

              <IonCol className='ion-no-padding font-roboto' size='6'>
                <SingleSelect
                  dataTestID='Consciousness'
                  selectedOption={headLossCons}
                  listHeader={t('neuro.Consciousness')}
                  label={t('neuro.Consciousness')}
                  options={headLossConsOptions}
                  action={setConsciousnessOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <AccordianComponent
              hasToggle={true}
              isToggleChecked={_toggleWasPtImmFlag}
              heading={t('neuro.wasPatientImmobilized.WasPatientImmobilized')}
              content={<WasPatientImmobilized />}
              toggleAction={toggleWasPatientImmobilizedData}
              isCheckMark={isAccordionCheckMark}
            />
            <IonRow className='gray-bg'>
              {DP_INITGCS === 1 && (
                <IonCol>
                  <ScoreButton
                    label={t('neuro.glassgowCommaScore.GlassgowCommaScore')}
                    score={gcsTotal}
                    onClickAction={() => {
                      history.push(TabConstants.GLASSGOW_COMMA_SCORE)
                    }}
                  />
                </IonCol>
              )}
              {showRtsFlag && ageFlag && (
                <IonCol>
                  <ScoreButton
                    label={t('neuro.pediatricTraumaScore.pediatricTraumaScore')}
                    score={ptsScore}
                    onClickAction={() => {
                      history.push(TabConstants.PEDIATRIC_TRAUMA_SCORE)
                    }}
                  />
                </IonCol>
              )}
              {DP_RTS === 1 && showRtsFlag && !ageFlag && (
                <IonCol>
                  <ScoreButton
                    label={t('neuro.revisedTraumaScore.RevisedTraumaScore')}
                    score={rtsScore}
                    onClickAction={() => {
                      history.push(TabConstants.REVISED_TRAUMA_SCORE)
                    }}
                  />
                </IonCol>
              )}
              {allowedScoreIds.size > 0 && (
                <IonCol>
                  <ScoreButton
                    label={t('neuro.strokeScore.StrokeScore')}
                    score={strokescaleScore}
                    isRed={true}
                    onClickAction={() => {
                      history.push(TabConstants.STROKE_SCORE)
                    }}
                  />
                </IonCol>
              )}
            </IonRow>
          </IonGrid>
        </IonList>
      </>
    </>
  )
}

export default NeuroContent
